<template>
	<div v-if="visible">
		<el-dialog class="add-server"
			:visible.sync="visible"
			:title="title"
			:close-on-click-modal="false"
			:before-close="handleClose"
			top="10%">
			<el-form ref="serverGroupNameForm" :rules="rules" :model="form" label-width="150px">
				<!-- 负载均衡所属VPC -->
				<el-form-item 
					:label="$t('slb.serverGroup.slbVpcName') | withColon"
					>
					{{slbVpcName}}
				</el-form-item>
				<!-- 虚拟服务器组名称 -->
				<el-form-item 
					:label="$t('slb.serverGroup.serverGroupName') | withColon"
					prop="serverGroupName"
					class="server-group-name">
					<el-input v-model="form.serverGroupName"></el-input>
					<p slot="hint">{{ $t('privateNetwork.nameHelp') }}</p>
				</el-form-item>
			</el-form>
			<el-form ref="chosenForm" label-width="130px" >
				<!--已选实例-->
				<el-form-item :label="$t('slb.serverGroup.chosenServer') | withColon">
					<el-table :data="chosenList"
						border
						max-height="205"
						style="width: 100%;"
						@selection-change="chosenSelectionChange"
						ref="chosen"
						class="chosen-table"
						:empty-text="$t('speechCraft.listEmptyText')">
						<el-table-column type="selection"></el-table-column>
						<el-table-column :label="$t('slb.serverGroup.sourceType')"
							min-width="105">
							<template>
								{{ $t('slb.text.cps')  }}
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.instanceName')">
							<template slot-scope="scope">
								<el-tooltip placement="bottom" :content="scope.row.name">
									<p class="cell-text"> {{ scope.row.name }}</p>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.instanceId')"
							prop="instanceId" min-width="120">
							<template slot-scope="scope">
								<el-tooltip placement="bottom" :content="scope.row.instanceId">
									<p class="cell-text">{{ scope.row.instanceId }}</p>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.region')" min-width="90">
							<template slot-scope="scope">
								<p>{{ transformInstanceRegion(scope.row.az) }}</p>
							</template>
						</el-table-column>
						<!--目标内网IP地址-->
						<el-table-column :label="$t('eip.text.targetPrivateIpAddress')"
							prop="selectedIpAddress"
							min-width="120">
							<template slot-scope="scope">
								<div v-if="scope.row.iptype">
									<p v-if="scope.row.iptype === '0'">{{`${scope.row.rip}(${$t('privateNetInstance.intranetIp')})`}}</p>
									<p v-else>
										{{`${scope.row.aliasip}(${$t('subnet.text.ipAlias')})`}}
									</p>
								</div>
								<div v-else>
									<p v-if="scope.row.selectedIpAddress === scope.row.privateIp || scope.row.selectedIpAddress === scope.row.extensionPrivateIp">{{`${scope.row.selectedIpAddress}(${$t('privateNetInstance.intranetIp')})`}}</p>
									<p v-else>
										{{`${scope.row.selectedIpAddress}(${$t('subnet.text.ipAlias')})`}}
									</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.status')"
							prop="status">
							<template slot-scope="scope">
								<p>{{ transformInstanceStatus(scope.row.status) }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.port')" min-width="90">
							<template slot-scope="scope">
								<el-form-item :prop="'port' + scope.$index"
									:rules="portRules"
									slot="reference"
									:show-message="false">
									<el-input v-model.trim="scope.row.port"
										@blur="getCurrentIndex(scope.$index)"
										:ref="'port' + scope.$index"
										:placeholder="$t('slb.serverGroup.portRangePlaceHolder')">
										{{ scope.row.port }}
									</el-input>
								</el-form-item>
								<error-tip :content="scope.row.portValidateMessage"
									:arrowPosition="'right'"
									v-if="!scope.row.portPassValidate">
								</error-tip>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.weights')">
							<template slot-scope="scope">
								<el-form-item :prop="'weight' + scope.$index"
									:rules="weightRules"
									slot="reference"
									:show-message="false">
									<el-input v-model.trim="scope.row.weight"
										@blur="getCurrentIndex(scope.$index)"
										:ref="'weight' + scope.$index"
										:placeholder="$t('slb.serverGroup.weightRangePlaceHolder')">
										{{ scope.row.weight }}
									</el-input>
								</el-form-item>
								<error-tip :content="$t('slb.serverGroup.weightRange')"
									:arrowPosition="'left'"
									v-if="!scope.row.weightPassValidate">
								</error-tip>
							</template>
						</el-table-column>
					</el-table>
					<div class="table-footer">
						<el-button type="primary"
							@click="delServer"
							class="footer-add">
							{{ $t('slb.serverGroup.delete') }}
						</el-button>
					</div>
				</el-form-item>
			</el-form>
			<!--可选实例-->
			<el-form :model="form"
				ref="editWeight"
				label-width="130px">
				<el-form-item :label="$t('slb.serverGroup.optionalServer') | withColon">
				</el-form-item>
				<!--网络网口数量-->
				<el-form-item :label="$t('eip.text.internetAccessType') | withColon" >
					<el-radio-group v-model="selectInternetAccessType" @change="changeInternetAccessType">
						<el-radio-button v-for="item in internetAccessTypes" :key="item.label" :label="item.label">
							{{item.value}}
						</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<!--目标网络接口名称-->
				<el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon" >
					<span v-if="selectInternetAccessType === 'bond'">
						{{$t('eip.text.singleInternetAccessChiefName')}}
					</span>
					<el-radio-group v-else 
						v-model="selectTargetInternetAccessName" 
						@change="changeTargetInternetAccessName">
						<el-radio-button v-for="item in targetInternetAccessNames" :key="item.label" :label="item.label">
							{{item.value}}
						</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<!--实例网口所属VPC-->
				<el-form-item :label="$t('slb.serverGroup.instanceVpcName') | withColon" >
					{{slbVpcName}}
				</el-form-item>
				<!--搜索框-->	
				<el-form-item>
					<div class="value-area">
						<el-select v-model="form.searchType"
							@change="searchTypeChange">
							<el-option v-for="searchType in types"
								:key="searchType.value"
								:value="searchType.value"
								:label="searchType.label"></el-option>
						</el-select>
						<el-input icon="jc-icon-search"
							v-model.trim="form.searchValue"
							:on-icon-click="handleIconClick"
							:placeholder="placeholders[form.searchType]"
							class="value-area-search">
						</el-input>
						<el-button slot="append"
							icon="jc-icon-search"
							class="search-icon"
							@click="handleIconClick">
						</el-button>
					</div>
				</el-form-item>
				<el-form-item>
					<el-table :data="optionalList"
						style="width:100%"
						border
						max-height="168"
						@selection-change="optionalSelectionChange"
						ref="optional"
						:empty-text="$t('speechCraft.listEmptyText')">
						<el-table-column type="selection"></el-table-column>
						<el-table-column :label="$t('slb.serverGroup.sourceType')"
							min-width="105">
							{{ $t('slb.text.cps') }}
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.instanceName')">
							<template slot-scope="scope">
								<el-tooltip placement="bottom" :content="scope.row.name">
									<p class="cell-text"> {{ scope.row.name }}</p>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.instanceId')"
							prop="instanceId" min-width="120">
							<template slot-scope="scope">
								<el-tooltip placement="bottom" :content="scope.row.instanceId">
									<p class="cell-text">{{ scope.row.instanceId }}</p>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.region')" min-width="90">
							<template slot-scope="scope">
								<p>{{ transformInstanceRegion(scope.row.az) }}</p>
							</template>
						</el-table-column>
						<!--目标内网IP地址-->
						<el-table-column :label="$t('eip.text.targetPrivateIpAddress')" min-width="175">
							<template slot-scope="scope">
								<span>
									<el-select v-model="scope.row.selectedIpAddress"  filterable
										@visible-change="value=>getAvailablePrivateIps(value,scope.row)"
										popper-class="ip-address-select"
										:no-data-text="$t('subnet.text.noAvailableIpAddress')"
										:placeholder="$t('eip.help.ipAddressSearch')">
										<el-option v-for="item in scope.row.ipAddressOptions" 
											:key="item.value"
											:label="item.label" 
											:value="item.value">
										</el-option>
									</el-select>
								</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('slb.serverGroup.status')"
							prop="status">
							<template slot-scope="scope">
								<p>{{ transformInstanceStatus(scope.row.status) }}</p>
							</template>
						</el-table-column>
					</el-table>
					<div class="table-footer">
						<el-tooltip :disabled="!isOverLimit"
							:content="this.$t('slb.serverGroup.numberLimit')">
							<label class="footer-add">
								<el-button type="primary"
									@click="addServer"
									:disabled="isOverLimit">
									{{ $t('slb.serverGroup.add') }}</el-button>
							</label>
						</el-tooltip>
						<span class="footer-add">{{ $t('slb.serverGroup.addServerTip') }}</span>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelAdd">{{ $t('slb.serverGroup.cancel') }}</el-button>
				<el-button @click="sureAdd" type="primary">{{ $t('slb.serverGroup.sure') }}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	TargetIpAddressChannelConstant
} from '@/common/Constants';
import ErrorTip from '@/components/slb/detail/defaultServerGroup/ErrorTip';
import { deepCopy } from '@/common/tool'

export default {
	name: 'AddServe',
	components: {
		ErrorTip
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		region: { // 所在区域
			type: String,
			default: ''
		},
		loadBalancerId: { // 负载均衡Id
			type: String,
			default: ''
		},
		slbVpcName: {
			type: String, // 负载均衡vpc网络
			default: ''
		},
		operationType: { // 区分操作类型[增加， 编辑]
			type: String,
			default: ''
		},
		title: { // dialog的title
			type: String,
			default: ''
		},
		rowInfo: { // 操作类型为编辑时带入的信息
			type: Object,
			default() {
				return {
					name: ''
				};
			}
		}
	},
	data() {
		/**
		 * 校验端口值
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const portValidate = (rule, value, callback) => {
			const portRule = /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]{1}|6553[0-5])$/;
			value = this.$refs[`port${this.index}`].value;
		 // console.log(this.$refs[`port${this.index}`], '--current--ref--');
			if (!portRule.test(value)) {
			//  console.log(value, this.index, 'port--value');
				this.$set(this.chosenList[this.index], 'portPassValidate', false);
				this.$set(this.chosenList[this.index], 'portValidateMessage', this.$t('slb.serverGroup.portRange'));
				callback(new Error());
			} else if (!this.isTheUniquePortValue(value)) {
				this.$set(this.chosenList[this.index], 'portPassValidate', false);
				this.$set(this.chosenList[this.index], 'portValidateMessage', this.$t('slb.serverGroup.portNumberTip'));
				callback(new Error());
			} else {
				this.$set(this.chosenList[this.index], 'portPassValidate', true);
				callback();
			}
		};
		/**
		 * 校验权重
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const weightValidate = (rule, value, callback) => {
			const weightRule = /^([1-9]\d{0,1}|100)$/;
			value = this.$refs[`weight${this.index}`].value;
			if (!weightRule.test(value)) {
				this.$set(this.chosenList[this.index], 'weightPassValidate', false);
				callback(new Error(this.$t('slb.sentence.weightTip')));
			} else {
				this.$set(this.chosenList[this.index], 'weightPassValidate', true);
				callback();
			}
		};
		/**
		 * 校验服务器组名称
		 * @param rule
		 * @param value
		 * @param callback
		 */
		const validateServerGroupName = (rule, value, callback) => {
			const nameRule = /^[-0-9a-zA-Z_\u4e00-\u9fa5]{1,32}$/;
			if (this.rowInfo.name === this.form.serverGroupName) {
				if (!value) {
					callback(new Error(this.$t('privateNetwork.nameNotNull')));
				} else if (!nameRule.test(value)) {
					callback(new Error(this.$t('privateNetwork.nameHelp')));
				} else {
					callback();
				}
			} else {
				if (!value) {
					callback(new Error(this.$t('privateNetwork.nameNotNull')));
				} else if (!nameRule.test(value)) {
					callback(new Error(this.$t('privateNetwork.nameHelp')));
				} else {
					this.checkServerGroupName(value).then((isDuplication) => {
						console.log(isDuplication, '---isPassCheck');
						if (isDuplication) {
							callback(new Error(this.$t('slb.serverGroup.nameDuplicate')));
						} else {
							callback();
						}
					});
				}
			}
		};
		return {
			rules: {serverGroupName: [{ validator: validateServerGroupName, trigger: 'blur' }]},
			types: [
				{
					value: 'name',
					label: this.$t('slb.serverGroup.instanceName')
				},
				{
					value: 'instanceIds',
					label: this.$t('slb.serverGroup.instanceId')
				}
			],
			placeholders: {
				name: this.$t('slb.sentence.nameSearch'),
				id: this.$t('slb.sentence.idSearch'),
			},
			form: {
				searchType: 'name', // 默认按实例名称搜索
				searchValue: '',
				serverGroupName: this.rowInfo.name, // 虚拟服务器组名称
				serverGroupId: this.rowInfo.serverGroupId // 虚拟服务器组id
			},
			// 端口校验规则
			portRules: { validator: portValidate, trigger: 'blur' },
			// 权重校验规则
			weightRules: { validator: weightValidate, trigger: 'blur' },
			// 可选实例
			optionalList: [],
			// 已选实例
			chosenList: [],
			// 当前选中态的即将添加的实例
			currentAddList: [],
			multipleSelectionInstanceInfo: {},
			// 当前选中的即将删除的实例
			currentDeleteList: [],
			// 当前index
			index: 0,
			// az对照表
			azs: {},
			// 已经选择的实例 编辑时使用
			hasChosenList: [],
			// 每一条实例增加一个_delIndex
			delIndex: 0,
			// 编辑时，删除已选实例时，记录删除的'init'
			deleteInitList: [],
			//网口数量
			internetAccessTypes: [{
				label: 'bond',
				value: this.$t('eip.text.singleInternetAccess')
			},{
				label: 'dual',
				value: this.$t('eip.text.doubleInternetAccess')
			}],
			selectInternetAccessType: 'bond',
			//目标网络接口名称
			targetInternetAccessNames: [
				{
					label: 'chief',
					value: this.$t('eip.text.singleInternetAccessChiefName')
				}
			],
			selectTargetInternetAccessName: 'chief',
		};
	},
	computed: {
		/**
		 * 服务器组内已选实例数量和
		 * 可选实例内当前选中的实例数量总和是否超过100
		 * @return {boolean}
		 */
		isOverLimit() {
			return this.chosenList.length + this.currentAddList.length > 100 || this.currentAddList.some(item => !item.selectedIpAddress);
		},
		TargetIpAddressChannelConstant: () => TargetIpAddressChannelConstant

	},
	created() {
		this.getOptionalList();
		if (this.operationType === 'edit') {
			this.getAddedInstance();
		}
		this.getFilterLists();
	},
	methods: {
		/**
		 * 检查虚拟服务器组名称是否重复
		 * @param serverGroupName
		 * @return Promise
		 */
		async checkServerGroupName(serverGroupName) {
			const params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
				serverGroupName
			};
			const json = await Ajax.get('/api/cps/checkServerGroupsName', params)
				.then(res => res.data.success);
			console.log(json, '---isDuplication---');
			return json;
		},
		/**
		 * 当改变搜索类型时清空之前搜索值
		 */
		searchTypeChange() {
			this.form.searchValue = '';
		},
		/**
		 * 编辑虚拟服务器组时调用
		 * 获取该服务器组已经关联的后端服务器
		 */
		getAddedInstance() {
			const params = {
				region: this.region,
				serverGroupId: this.rowInfo.serverGroupId,
				pageSize: 100,
				pageNumber: 1
			};
			const initStatue = {
				weightPassValidate: true,
				portPassValidate: true,
				portValidateMessage: '',
				init: 'init' // 表示编辑时已经选择的实例
			};
			Ajax.get('/api/cps/serverGroups/listServers', params)
			.then((res) => {
				this.hasChosenList = res.data.servers.map((server) => {
					initStatue._delIndex = this.delIndex++;
					return Object.assign({}, server, initStatue);
				});
				this.delIndex = this.hasChosenList.length === 0 ? 0 : this.hasChosenList.length;
				this.chosenList = res.data.servers.map((server) => {
					initStatue._delIndex = this.delIndex++;
					server.selectedIpAddress = server.iptype ===  '0' ? server.rip : server.aliasip;
					return Object.assign({}, server, initStatue); // 1是别名IP，0是内网IP
				});
			})
			.catch();
		},
		/**
			* 获取azs对照
		*/
		getFilterLists() {
			const params = {
				region: this.region,
				networkType: 'vpc'
			};
			Ajax.get('/api/filter/listInstances', params)
			.then((res) => {
				this.azs = res.data.azs;
			});
		},
		/**
			* 返回可用区名称
			* @return String
		*/
		transformInstanceRegion(region) {
			return this.azs[region];
		},
		/**
			* 转化实例状态显示
			* @param status
			* @return String
		*/
		transformInstanceStatus(status) {
			switch (status) {
				case 'running':
					return this.$t('privateNetInstance.statueNames.running');
				case 'stopped':
					return this.$t('privateNetInstance.statueNames.stopped');
				case 'starting':
					return this.$t('privateNetInstance.statueNames.starting');
				case 'stopping':
					return this.$t('privateNetInstance.statueNames.stopping');
				case 'restarting':
					return this.$t('privateNetInstance.statueNames.restarting');
				case 'upgrading':
					return this.$t('privateNetInstance.statueNames.upgrading');
				case 'reinstalling':
					return this.$t('privateNetInstance.statueNames.reinstalling');
				case 'destroying':
					return this.$t('privateNetInstance.statueNames.destroying');
				case 'resetting_password':
					return this.$t('privateNetInstance.statueNames.resetting_password');
				default:
					return status;
			}
		},
		/**
			* 判断端口值是否唯一, 因为不应该和本身做比较
			* 所以当循环到本身时返回true，不影响整体返回结果
			* @param value
			* @return
		*/
		isTheUniquePortValue(value) {
			const target = this;
			// console.log(target.chosenList.filter(item => item.instanceId === target.chosenList[this.index].instanceId));
			return target.chosenList.filter((item, index) => item.selectedIpAddress === target.chosenList[this.index].selectedIpAddress && index !== target.index).every((item, index) => {
				if (target.index !== index) {
					return item.port.toString() !== value;
				}
				return true;
			});
		},
		/**
			* 点击查询图标
		*/
		handleIconClick() {
			this.getOptionalList();
		},
		/**
			* 获取当前index
			* 供校验使用
			* @param index
		*/
		getCurrentIndex(index) {
			this.index = index;
		},
		// 切换网络接口数量
		changeInternetAccessType(label) {
			if (label === 'bond') {
				this.targetInternetAccessNames = [{
					label: 'chief',
					value: this.$t('eip.text.singleInternetAccessChiefName')
				}];
			} else if (label === 'dual') {
				this.targetInternetAccessNames = [{
					label: 'chief',
					value: this.$t('eip.text.chiefInternetAccessName')
				},
				{
					label: 'sub',
					value: this.$t('eip.text.subInternetAccessName')
				}];
			}
			this.selectTargetInternetAccessName = 'chief';
			this.getOptionalList();
		},
		// 切换目标网络接口名称
		changeTargetInternetAccessName(label) {
			// let optionalList = deepCopy(this.optionalList);
			// optionalList.map((item, index) => {
			// 	item.selectedIpAddress = '';
			// })
			// this.optionalList = optionalList;
			this.getOptionalList();
		},
		/**
			* 获取可选实例列表
		*/
		getOptionalList() {
			const params = {
				region: this.region,
				loadBalancerId: this.loadBalancerId,
				pageSize: 100,
				pageNumber: 1,
				networkType: 'vpc',
				'interfaceMode'	: this.selectInternetAccessType, 
			};
			if (this.form.searchValue !== '') {
				params[this.form.searchType] = this.form.searchValue;
			}
			let ethernetPort;
			let selectTargetInternetAccessName = this.selectTargetInternetAccessName;
			if (selectTargetInternetAccessName === 'chief') {
				ethernetPort = 'eth0'
			} else if (selectTargetInternetAccessName === 'sub') {
				ethernetPort = 'eth1'
			}
			Ajax.get('/api/cps/serverGroups/listInstances', params)
			.then((res) => {
				const list = res.data.instances;
				list.map((item, index) => {
					item.index = index;
					item.ipAddressOptions = [];
					item.selectedIpAddress = '';
				})
				this.optionalList = list.filter(item => item.ethernetPort === ethernetPort);
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			});
		},
		/**
			* 点击可选实例添加时调用
		*/
		addServer() {
			if (this.currentAddList.length !== 0) {
				const initStatue = {
					weightPassValidate: true,
					portPassValidate: true,
					portValidateMessage: '',
					port: '',
					weight: 20
				};
				this.currentAddList.forEach((item) => {
					initStatue._delIndex = this.delIndex++;
					this.chosenList.push(Object.assign({}, initStatue, item));
				});
			}
			this.$refs.optional.clearSelection();
		},
		/**
			* 点击删除时调用
			* 同时记录删除的带init字段的实例
		*/
		delServer() {
			const target = this;
			target.currentDeleteList.forEach((currentItem) => {
				if (typeof currentItem.init !== 'undefined') {
					this.deleteInitList.push(currentItem);
				}
				target.chosenList.forEach((item, index) => {
					if (currentItem._delIndex === item._delIndex) {
						target.chosenList.splice(index, 1);
					}
				});
			});
			this.$refs.optional.clearSelection();
		},
		/**
			* 获取最当前可选实例列表中选中项
			* @param val
		*/
		optionalSelectionChange(val) {
			this.currentAddList = val;
			let multipleSelectionInstanceInfo = {};
	   		this.currentAddList.map(item => {
	   			multipleSelectionInstanceInfo[item.instanceId] = item;
	   		})
	   		this.multipleSelectionInstanceInfo = multipleSelectionInstanceInfo;
		},
		/**
			* 获取已选实例列表中选中项
			* @param val
		*/
		chosenSelectionChange(val) {
			this.currentDeleteList = val;
		},

		// 获取当前实例的可用的私有IP列表
		getAvailablePrivateIps(isVisible, row) {
			if (!isVisible) {
				return
			}
			let index = row.index;
			let params = { 
				region: row.region, 
				instanceId: row.instanceId,
				subnetId: this.selectTargetInternetAccessName === 'chief' ? row.subnetId : row.extensionSubnetId,
				channel: TargetIpAddressChannelConstant.VMSG

			}
			Ajax.get('/api/cps/availablePrivateIps', params)
			.then((res) => {
				let optionalList = deepCopy(this.optionalList);
				optionalList[index].ipAddressOptions = [];
				let availablePrivateIps = res.data.availablePrivateIps;
				availablePrivateIps = availablePrivateIps.map(item=>{
					const formattedItem = {
						value: item,
						label: ''
					};
					if (item === row.privateIp || item === row.extensionPrivateIp) {
						formattedItem.label = `${item}(${this.$t('privateNetInstance.intranetIp')})`;
					} else {
						formattedItem.label = `${item}(${this.$t('subnet.text.ipAlias')})`;
					}
					return formattedItem
				})
				optionalList[index].ipAddressOptions = availablePrivateIps;
				// 增加interfaceName字段作为添加时候传递给后端的参数
				optionalList[index].interfaceName = this.selectTargetInternetAccessName;
				this.optionalList = optionalList;
				// 恢复之前选中的值
				let multipleSelectionInstanceInfo = deepCopy(this.multipleSelectionInstanceInfo)
				this.$nextTick(() => {
		    		this.optionalList.map(item => {
						let instanceId = item.instanceId;
						if (multipleSelectionInstanceInfo[instanceId]) {
		        			this.$refs.optional.toggleRowSelection(item,true)
		        		}
					})
		      	})
			})
			.catch()
			.finally();
		},
		/**
			* 更新组件状态
		*/
		handleClose() {
			this.$emit('update:visible', false);
		},
		/**
			* 点击取消时
		*/
		cancelAdd() {
			this.handleClose();
		},
		/**
			* 点击确定时
		*/
		sureAdd() {
			this.$refs.serverGroupNameForm.validate((valid) => {
				if (valid) {
					this.chosenList.forEach((chosen, index) => {
						this.index = index;
						this.$refs.chosenForm.validateField([`port${index}`, `weight${index}`]);
					});
					const chosenListPass = this.chosenList.every(choose => choose.portPassValidate && choose.weightPassValidate);
					if (chosenListPass) {
						this.$emit('handleClickAdd', this.form.serverGroupName, this.chosenList, this.operationType, this.form.serverGroupId, this.deleteInitList);
						this.handleClose();
					}
				} else {
					return false;
				}
			});
		}
	},
};
</script>

<style lang="scss">
	.add-server {
		.el-dialog {
			p {
				margin-bottom: 0;
			}
		}

		.cell-text {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		
		.el-form-item-help {
			display: block;
			line-height: 16px;
			padding-top: 2px;
			font-size: 12px;
			margin: 0;
			color: #9e9e9e;
		}

		.server-group-name {

			.el-input {
				width: 90% !important;
			}

			.el-form-item__label {
				&::before {
					content: '*';
					color: #ff3a3a;
					margin-right: 4px;
				}
			}
		}


		.el-dialog--small {
			width: 800px;
		}

		.chosen-table {
			.el-form {
				padding-right: 0;
			}
		}

		.value-area {
			display: flex;

			.el-select {
				width: 135px;
			}

			.value-area-search {
				width: 270px;
			}
		}

		.table-footer {
			display: flex;
			align-items: center;
			height: 40px;
			background-color: #f3f7fb;
			border: 1px solid #d9e1e9;
			border-top: none;

			.footer-add {
				margin-left: 10px;
				line-height: 15px;
			}
		}

		.el-form-item__content {
			display: block;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/slb/detail/defaultServerGroup/Addserver.vue